// extracted by mini-css-extract-plugin
export default {"guidelines":"style--guidelines--116af3"};